<template>
  <transition v-if="showModal" name="modal">
    <ValidationObserver
      ref="obs"
      v-slot="{ invalid, passes, validate, validated }"
    >
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <div class="modal-buttons">
                <!-- <a class="btn-close" @click="closeModal" >X</a> -->
                <a class="close" @click="closeModal"></a>
              </div>
              <div class="header-content">
                <h3>
                  {{
                    translationHelper.getTranslation("ig_title_angebot_detail")
                  }}
                </h3>
              </div>
            </div>
            <div class="row modal-row body-content">
              <div class="large-20 columns">
                <label>{{
                  translationHelper.getTranslation("ig_label_angebot_name")
                }}</label>
              </div>
              <div class="large-20 columns">
                <ValidationProvider
                  v-slot="{ valid }"
                  name="name"
                  rules="required"
                  mode="lazy"
                >
                  <input
                    type="text"
                    :value="localOffer.shortName"
                    @input="update('shortName', $event.target.value)"
                  />
                  <span class="validationMessage" v-if="validated && !valid">{{
                    translationHelper.getTranslation(
                      "ig_validator_offer_name_required"
                    )
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="large-20 columns">
                <label>{{
                  translationHelper.getTranslation("ig_label_angebot_url")
                }}</label>
              </div>
              <div class="large-20 columns">
                <input
                  type="text"
                  :value="localOffer.url"
                  @input="update('url', $event.target.value)"
                />
              </div>
              <div class="large-20 columns">
                <label>{{
                  translationHelper.getTranslation("ig_label_angebot_type")
                }}</label>
              </div>
              <div class="large-20 columns">
                <v-select
                  id="offerTypeId"
                  class="offer-type-select"
                  :options="availableOfferTypes"
                  code="id"
                  label="name"
                  :searchable="false"
                  :clearable="false"
                  :multiple="false"
                  :value="currentOfferType"
                  @input="setCurrentOfferType"
                >
                </v-select>
              </div>
            </div>
            <div class="row modal-row action-btns">
              <div class="large-20 columns">
                <input
                  type="button"
                  class="btn"
                  :disabled="isSaving"
                  :value="translationHelper.getTranslation('ig_button_save')"
                  @click="save"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </transition>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import InteraktiveGrafik from "../../../../_Api/InteraktiveGrafik";
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
      required: true
    },
    offer: {
      type: Object,
      default: () => {}
    },
    topicId: {
      type: String,
      default: ""
    },
    method: {
      type: String,
      default: ""
    },
    glassItemData: {
      type: Object,
      default: () => {}
    },
    availableOfferTypes: {
      type: Array,
      default: () => []
    },
    translationHelper: {
      type: Object
    },
  },
  data() {
    return {
      currentOfferType: null,
      isSaving: false
    }
  },
  model: {
    prop: "offer",
    event: "changed"
  },
  computed: {
    localOffer() {
      this.findAndSetOfferType();
      return this.offer;
    }
  },
  methods: {
    findAndSetOfferType() {
      let found = this.availableOfferTypes.find(
        (x) => x.id == this.offer.offerTypeId
      );
      if (found) {
        this.setCurrentOfferType(found);
      } else {
        this.setCurrentOfferType(this.availableOfferTypes[0]);
      }
    },
    setCurrentOfferType(selectedOfferType) {
      if (
        this.currentOfferType == null ||
        this.currentOfferType.id != selectedOfferType.id || 
        this.offer.offerTypeId == null
      ) {
        this.currentOfferType = selectedOfferType;
        this.offer.offerTypeId = selectedOfferType.id
        this.update("offerTypeId", selectedOfferType.id);
      }
    },
    update(key, value) {
      this.$emit("changed", { ...this.offer, [key]: value });
    },
    async save() {
      this.isValidObs = await this.$refs.obs.validate();
      if (this.isValidObs) {
        this.isSaving = true;
        if (this.method == "save") {
          delete this.localOffer.id;
          let queryData = {
            ...this.glassItemData,
            ["offer"]: this.localOffer,
            ["topicId"]: this.topicId
          };
          InteraktiveGrafik.addOfferToTopic(queryData).then((response) =>
            this.offerSaved(response)
          );
        } else {
          let queryData = {
            ...this.glassItemData,
            ["offer"]: this.localOffer,
            ["topicId"]: this.topicId
          };
          InteraktiveGrafik.updateOffer(queryData).then((response) =>
            this.offerSaved(response)
          );
        }
      }
    },
    offerSaved(response) {
      if (response.status == 200) {
        this.localOffer.id = response.data.id;
      }
      this.$emit("saved", { offer: this.localOffer, status: response.status });
      this.isSaving = false;
    },
    closeModal() {
      this.$emit("close-window");
    }
  }
};
</script>

<style>
</style>